import * as UserApiUtil from "../../util/user_util";
import { returnUpdatedWip } from "./wi_actions";
export const RECEIVE_ALL_USERS = "RECEIVE_ALL_USERS"
// export const RECEIVE_USER = "RECEIVE_ALL_USER"
export const RECEIVE_USER = "RECEIVE_USER"
export const UPDATE_USER = "UPDATE_USER"
export const VERIFY_SUPERVISOR = "VERIFY_SUPERVISOR"
export const RECEIVE_USER_NOTIFICATIONS = "RECEIVE_USER_NOTIFICATIONS"
export const UPDATE_USER_NOTIFICATIONS = "UPDATE_USER_NOTIFICATIONS"
export const UPDATE_USER_NOTIFICATIONS_READ = "UPDATE_USER_NOTIFICATIONS_READ"
export const UPDATE_USER_IMAGE = "UPDATE_USER_IMAGE"
export const RECEIVE_ALL_NOTIFICATIONS = "RECEIVE_ALL_NOTIFICATIONS"
export const USER_UPDATE_STEP_DOWN = "USER_UPDATE_STEP_DOWN"

const receiveAllUsers = (users) => {
    return {
        type: RECEIVE_ALL_USERS,
        users
    }
}


const receiveUser = (newUser) => {
    return {
        type: RECEIVE_USER,
        user: newUser
    };
};

const returnUpdatedUser = user => {
    return {
        type: UPDATE_USER,
        notifications: user.notifications,
        user
    };
};

const receiveUserNotifications = (notifications, userId) => {
    return {
        type: RECEIVE_USER_NOTIFICATIONS,
        notifications,
        userId
    };
};

const receiveAllNotifications = (notifications) => {
    return {
        type: RECEIVE_ALL_NOTIFICATIONS,
        notifications
    };
}

const updateUserNotificationsRead = (notifications) => {
    return {
        type: UPDATE_USER_NOTIFICATIONS_READ,
        notifications
    };
};

const receiveUpdatedUserRole = user => {
    return {
        type: UPDATE_USER,
        user
    };
}
const receiveUserImage = user => {
    return {
        type: UPDATE_USER_IMAGE,
        user
        // user: {
        //     id: user.id,
        //     image: user.image
        // }
    };
}

const returnUser = (user) =>{
    return{
       type: VERIFY_SUPERVISOR,
       user
    } 
}

const returnUserStepsDone = (user) =>{
    return{
       type: USER_UPDATE_STEP_DOWN,
       user
    } 
}

export const oversightVerification = (creds) => dispatch =>{
   return UserApiUtil.oversightVerification(creds)
   .then(user => {dispatch(returnUser(user))})

}

export const createUser = (user) => dispatch => {
    return UserApiUtil.createUser(user)
        .then(newUser => {
            dispatch(receiveUser(newUser));
            return newUser; // return newUser so it can be used in the component
        });
};

export const fetchAllUsers = (cancelToken) => dispatch => {
    return UserApiUtil.fetchAllUsers(cancelToken)
        .then(users => { dispatch(receiveAllUsers(users)) })
};

export const fetchUserNotifications = (userId) => dispatch => {
    return UserApiUtil.fetchUserNotifications(userId).then(
        notifications => {
            dispatch(receiveUserNotifications(notifications, userId))
        })
}

export const fetchIncomingNotifications = (userId) => dispatch => {
    return UserApiUtil.fetchIncomingNotifications(userId).then(
        notifications => dispatch(receiveUserNotifications(notifications, userId))
    );
};

export const fetchAllNotifications = (fetchUnread, currentUserId) => dispatch => {
    return UserApiUtil.fetchAllNotifications(fetchUnread, currentUserId)
    .then(notifications => dispatch(receiveAllNotifications(notifications)))
}


export const assignUsers = (users, workInstructionId) => dispatch => {
    return UserApiUtil.updateWIAssignments(users, workInstructionId).then(user => {
        const removals = user.data.pendingUserRemovals;
        const adds = user.data.pendingUserAdditions;
        if(removals && removals.length > 0) {
            removals.forEach((removal) => {
                dispatch(returnUpdatedUser(removal[1]))
            });
        }
        if(adds && adds.length > 0) {
            adds.forEach((addition) => {
                dispatch(returnUpdatedUser(addition[1]))
            });
        }
        dispatch(returnUpdatedWip(user.data.wip));
    })
};

export const updateUserIdleStatus =()=> dispatch => {
    return UserApiUtil.updateUserIdleStatus().then(user => dispatch(returnUpdatedUser(user.data)) )
}

export const updateUserAssignmentProgress = (payload) => dispatch => {
    return UserApiUtil.updateAssignments(payload).then(user => dispatch(returnUpdatedUser(user.data)))
};

export const updateUserStepsDone = (payload) => dispatch => {
    return UserApiUtil.updateUserStepsDone(payload).then(user => dispatch(returnUpdatedUser(user.data)))
};

export const addNewNotification = (payload) => dispatch => {
    return UserApiUtil.addNotification(payload).then(user => dispatch(returnUpdatedUser(user.data)))
}
export const refreshUsersNotifications = (userId) => dispatch => {
    return UserApiUtil.fetchUserNotifications(userId).then(user => {
        dispatch(returnUpdatedUser(user))
    })
}

export const updateUserNotificationRead = (userId) => dispatch => {
  return UserApiUtil.updateUsersNotificationRead(userId).then(notifications => {
    dispatch(updateUserNotificationsRead(notifications.data));
  });
};

export const updateUserIDSetToNotification = (userId, fetchUnread) => dispatch => {
    return UserApiUtil.updateUserIDSetToNotification(userId, fetchUnread).then(notifications => {
        dispatch(receiveAllNotifications(notifications))
    })
}

export const updateUserRole = (payload) => dispatch => {
    return UserApiUtil.updateUserRole(payload).then(user => {
        dispatch(receiveUpdatedUserRole(user.data))
    })
}

export const storeProfileImage = (userId, image) => dispatch => {
    return UserApiUtil.storeProfileImage(userId, image).then(user => {
        let sessionUser = user
        sessionUser._id = user.id;
        delete sessionUser._id
        dispatch(receiveUserImage(sessionUser))
    })
}